import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enCommon from './locales/en-US/common.json'
import enValidation from './locales/en-US/validation.json'
import ptCommon from './locales/pt-BR/common.json'
import ptValidation from './locales/pt-BR/validation.json'

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    supportedLngs: ['en-US', 'pt-BR'],
    defaultNS: 'common',
    ns: ['common', 'validation'],
    resources: {
      'en-US': { common: enCommon, validation: enValidation },
      'pt-BR': { common: ptCommon, validation: ptValidation },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18next
